class BillEaseComponent extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute("data-id");
    this.rawPrice = this.getAttribute("data-price");
  }

  connectedCallback() {
    const marketingLink = "https://billease.ph";
    const isEasypace = true;
    const installments = 24;
    const dpPct = 0;
    const storageKey = "BILLEASE_INSTALLMENTS";
    const productId = this.variantId;
    const price = parseFloat(this.rawPrice) / 100;

    const billeaseLogo = `<a target="_blank" href="${marketingLink}" style="vertical-align: text-top"><img src="https://s3-ap-southeast-1.amazonaws.com/static.fdfc.io/billease-logo-billie.png" width="80"/></a>`;
    const container = this.querySelector(`#billease_installments_widget_product_page_${productId}`);
    if (!container) return;

    const roundUp = (val) => (val % 100 === 0 ? val : val + 100 - (val % 100));

    const insertBilleaseText = (installmentsData) => {
      const cashout = dpPct ? roundUp(price * (dpPct / 100)) : 0;
      const financedAmount = price - cashout;
      const factor = isEasypace
        ? installmentsData.annuity_factor
        : installmentsData.installment_factor;

      const monthlyAmount = Math.ceil(
        factor?.[installments]
          ? factor[installments] * financedAmount
          : financedAmount / installments
      );

      const amountText = `<strong>₱${monthlyAmount.toLocaleString()}</strong>`;
      const monthsText = `<strong>${installments} months</strong>`;
      const easypaceNote = isEasypace ? " — pay less interest over time." : "";

      const widgetText = cashout
        ? `Pay <strong>₱${cashout.toLocaleString()} upfront</strong>, the rest in ${monthsText} for only ${amountText}`
        : `As low as ${amountText} for ${monthsText}`;

      container.innerHTML = `<span>${widgetText} with ${billeaseLogo}${easypaceNote}</span>`;
    };

    const cached = localStorage.getItem(storageKey);
    if (cached) {
      insertBilleaseText(JSON.parse(cached));
    } else {
      fetch("https://billease.ph/billease_installments.json")
        .then((res) => res.json())
        .then((data) => {
          localStorage.setItem(storageKey, JSON.stringify(data));
          insertBilleaseText(data);
        })
        .catch((err) => {
          console.warn("Billease fetch failed:", err);
        });
    }
  }
}

if (!customElements.get("billease-component")) {
  customElements.define("billease-component", BillEaseComponent);
}
